import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { api } from "../lib/api";
import type { Tenant } from "@vereinfach/types";
import { useAuth } from "../lib/auth";

export function OnboardingPage() {
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { refetchMe } = useAuth();
  const navigate = useNavigate();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api<Tenant>("/tenants", {
        method: "POST",
        body: JSON.stringify({ name: name.trim() }),
      });
      await refetchMe();
      await navigate({ to: "/" });
    } catch (err) {
      setError((err as Error).message);
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-full flex items-center justify-center px-4">
      <form onSubmit={onSubmit} className="w-full max-w-sm">
        <h1 className="text-2xl font-semibold tracking-tight">Willkommen!</h1>
        <p className="mt-2 text-slate-500">Wie heisst dein Verein oder Studio?</p>
        <input
          type="text"
          required
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="z. B. Turnverein Musterdorf"
          className="mt-6 w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm focus:border-slate-900 focus:outline-none"
        />
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={submitting || name.trim().length === 0}
          className="mt-4 w-full rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-slate-800 disabled:opacity-50 transition"
        >
          {submitting ? "Erstellen…" : "Verein erstellen"}
        </button>
        <p className="mt-4 text-xs text-slate-400">
          Danach: Beiträge anlegen, Mitglieder importieren — Vereinfach erstellt die Rechnungen.
        </p>
      </form>
    </div>
  );
}
